import React, { useState, useEffect } from 'react';

import ReactPaginate from 'react-paginate';
import List from '../List/Contractor/ContractorList';

function ContractorPagination({ page, itemsPerPage }) {
  return (
    <div className="w-full flex flex-col">
      <List />
    </div>
  );
}

export default ContractorPagination;
